// Curated highlights for the "Previous work" page. This is a hand-edited
// list, not a database — add an entry, drop 1-3 images in public/work/, and
// redeploy. Full ongoing photo updates belong on Instagram, not here.
//
// Each entry: { title, description, images: ['/work/your-image.jpg', ...] }

const previousWork = [
  {
    title: 'Earth bank clearance & stump removal — Vale',
    description: 'A big groundworks job in the Vale: clearing a dead-elm earth bank and a large Lylandia root ball, rebuilding the bank, digging out stumps and clearing the debris. The kind of work the TB219 is built for — and all soil and roots cleared off-site properly, so nothing unwanted travels to the next garden.',
    images: ['/work/stump-removal.jpeg', '/work/close-up-stump.jpeg', '/work/earth-bank-clearance.jpeg'],
  },
];

export default previousWork;
